(function () {
  'use strict';

  angular
    .module('app.rankingScoreReportTopic')
    .controller('rankingScoreReportTopicCtrl', ['measureService', 'rankingScoreReportTopicService', '$scope','$rootScope','$http','$filter','filterFilter', '$state', 'localStorageService',
                                    function (measureService, rankingScoreReportTopicService, $scope, $rootScope, $http, $filter, filterFilter, $state, localStorageService) {

      var barChartConfig  = {
        options: {
          chart: {
            type: 'bar',
            zoomType: 'x'
          },
          tooltip: {
            enabled: false
          },
          plotOptions: {
            column: {
              dataLabels: {
                enabled: false
              },
              showInLegend: false
            },            
            series: {
              borderWidth: 0,
              dataLabels: {
                enabled: false,
                crop: false,
                overflow: 'none',
                format: '{point.y:.0f}'
              },
              pointWidth: 40,
              states: {
                  hover: {
                      enabled: false
                  }
              }
            }
          },
          credits: {
            enabled: false
          }
        },        
        series: [],
        title: {
          text: ''          
        },
        legend: {
            enabled: false
        },
        xAxis: {
          type: 'category',
          tickLength: 0
        },
        yAxis: {
          title: {
            text: false
          },
          labels: {
            enabled: false
          }
        },
        noData: 'Pending Data...',
        loading: true
      };   

      function getDataRankingScoreReportTopics(args) {
        var currentInfluencer = localStorageService.get('influencerInformation');
        if(currentInfluencer == null || !currentInfluencer.influencerChannels == null || currentInfluencer.influencerChannels.length == 0) {
          return;
        }
        var params = {
                mention : 0,
                blog_id : 0,
                project_id : 0,
                channel: currentInfluencer.influencerChannels[0].id
            };
        params.date = args.date ? args.date.value : $rootScope.selectedPeriod.period ? $rootScope.selectedPeriod.period.value : 7;
        
        getRankingScoreReportTopics(params);
      }

      function getRankingScoreReportTopics(params) {
        rankingScoreReportTopicService.getRankingScoreReportTopics(params)
          .then(function (response) {
            generateRankingScoreReportPosts(response.data.topics);
          })
          .catch(function (msg) {
            $scope.topics = [];
          })
          .finally(function () {
            $rootScope.$broadcast('sectionLoaded');
          });
      }

      function generateRankingScoreReportPosts(topics) {
        $scope.topics = [];
        var topic = {};

        _.forEach(topics, function (item) { 
          // topic information
          if(item.topic_name != "NA" && $scope.topics.length < 3){
            topic.name = item.topic_name;
            topic.value = item.ranking_number;
            topic.percent = Math.abs(item.ranking_change);
            if(item.ranking_change >= 0){
              topic.status = "asc";
            } else{
              topic.status = "desc";
            }
            topic.totalInfluencer = item.total_influencer;          
            topic.barChart = [
              {name: "reach", color: "#FF6C9D", percent: 0},
              {name: "engagement", color: "#00D6EF", percent: 0},
              {name: "activity", color: "#434348", percent: 0},
            ];
            topic.barChart[0].percent = Math.round(item.reach_percent);
            topic.barChart[1].percent = Math.round(item.engagement_percent);
            topic.barChart[2].percent = Math.round(item.activity_percent);


            $scope.topics.push(topic);
            topic = {};
          }                                  
        });
      }

      // first initiating
      getDataRankingScoreReportTopics({});
      
    }]);

})();